var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: "32px",
    viewBox: "0 0 32 32",
    width: "32px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gmail"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5,26.5h-25c-1.104,0-2-0.896-2-2v-17c0-1.104,0.896-2,2-2h25c1.104,0,2,0.896,2,2v17   C30.5,25.604,29.604,26.5,28.5,26.5z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.64,8.973L16,18.305L2.36,8.973C2.262,8.905,2.177,8.822,2.093,8.738l-0.013,0l17.715,17.716h8.728   c1.088,0,1.978-0.89,1.978-1.977V7.341C30.5,8.019,30.159,8.617,29.64,8.973z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5,7v17.542c0,1.082-0.877,1.958-1.958,1.958H27V7H30.5z",
    fill: "#FF8A80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,7v17.542c0,1.082,0.877,1.958,1.958,1.958H5V7H1.5z",
    fill: "#FF8A80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.522,5.364L16,13.932L3.478,5.364C2.39,5.364,1.5,6.254,1.5,7.341c0,0.677,0.341,1.275,0.86,1.631   L16,18.305l13.64-9.333c0.519-0.356,0.86-0.954,0.86-1.631C30.5,6.254,29.61,5.364,28.522,5.364z",
    fill: "#FF8A80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5,27h-25C2.122,27,1,25.878,1,24.5v-17C1,7.224,1.224,7,1.5,7S2,7.224,2,7.5v17   C2,25.327,2.673,26,3.5,26h25c0.827,0,1.5-0.673,1.5-1.5v-17C30,6.673,29.327,6,28.5,6C28.224,6,28,5.776,28,5.5S28.224,5,28.5,5   C29.878,5,31,6.122,31,7.5v17C31,25.878,29.878,27,28.5,27z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,19c-0.099,0-0.198-0.029-0.284-0.088L2.066,9.498C1.398,9.038,1,8.278,1,7.467C1,6.107,2.107,5,3.467,5   h25.065C29.893,5,31,6.107,31,7.467c0,0.811-0.398,1.57-1.066,2.031l-13.65,9.414C16.198,18.971,16.099,19,16,19z M3.467,6   C2.658,6,2,6.658,2,7.467C2,7.95,2.237,8.401,2.634,8.675L16,17.893l13.366-9.218C29.763,8.401,30,7.95,30,7.467   C30,6.658,29.342,6,28.533,6H3.467z",
    fill: "#455A64"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.0fee87b07713a7344a64663620166e25.svg";
export { ForwardRef as ReactComponent };